import { Classes, Icon } from '@blueprintjs/core';
import * as React from 'react';

import { PartStatus } from 'vms/features/parts/constants';

interface Props {
  disabled?: boolean;
  status: string;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => any;
  children?: React.ReactNode;
}

const PartStatusSelect = (props: Props) => (
  <div className={Classes.HTML_SELECT}>
    <select
      disabled={props.disabled}
      onChange={props.handleChange}
      value={props.status}
      name="status"
    >
      {props.children}
      {Object.entries(PartStatus).map(([status, label]) => (
        <option key={status} value={status}>
          {label}
        </option>
      ))}
    </select>
    <Icon icon="double-caret-vertical" />
  </div>
);

export default PartStatusSelect;
